import { useEffect, useRef, useState } from "react"
import InputForm from "./InputFormV2";
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import '../styles/react-quill.style.css';

interface PropsInputSwitchDescripcion {
    defaultEnrequecido: boolean
    className: string
    onChange: any
    onBlur: any
    required: any
    maxLength: number
    name: string
    placeholder: string
    label: string
    type: string
    id?: string
    value?: string
    error?: string
    autoComplete?: string
    autoFocus?: boolean
    disabled?: any
}

interface PropsCheckBox {
    label: string
    value: boolean
    onChange: any
}

const toolbarOptions = [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline'], // opciones de formato
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [], // enlaces e imágenes
    ['clean'] // limpia el formato
];

export const CheckBoxFlag = (props: PropsCheckBox) => {
    return (<InputForm 
        containerStyle={{ marginLeft: '16px', marginTop: '5px' }}  
        label = {props.label}
        type = 'checkbox' 
        value = {props.value} 
        onChange = {props.onChange}
    />)
}

export default function InputSwitchDescripcion (props: PropsInputSwitchDescripcion) {
    const [flagTextoEnrequecido, setFlagTextoEnrequecido] = useState<boolean>(props.defaultEnrequecido);
    const [contentActual, setContentActual] = useState(props.value);

    const validarStrVacio = (content: string):string => {
        if (content.length > (props.maxLength ?? -1)) {
            content = content.substring(0, props.maxLength);
        }
        return content;
    }

    const handleChangeCheck = () => {
        setFlagTextoEnrequecido(prevFlag => !prevFlag);
    }

    const handleOnChangeFormato = (content: string) => {
        const contentStr = validarStrVacio(content);
        
        // Solo actualizar si el contenido es realmente diferente
        if (contentStr !== contentActual) {
            const event = { target: { name: props.name, value: contentStr }};
            setContentActual(contentStr);
            props?.onChange(event);
        }
    }

    const handleOnBlurFormato = (editor: any) => {
        const simulatedBlurEvent = {
            target: { name: props.name, value: validarStrVacio(editor.getText()) }
        };
        props?.onBlur(simulatedBlurEvent);
    };

    const renderCheckBox = () => {
        return (
            <CheckBoxFlag 
                label="Activar texto con formato" 
                value={flagTextoEnrequecido} 
                onChange={handleChangeCheck} 
            />
        )
    }

    useEffect(() => {
        if (props.value !== contentActual && flagTextoEnrequecido) {
            setContentActual(props.value);
        }
    }, [props.value]);

    return (
        <>
            {
                (!flagTextoEnrequecido)
                ? (
                    <>
                        <InputForm 
                            id = {props.id}
                            className={props.className}
                            autoComplete = {props.autoComplete} 
                            autoFocus = {props.autoFocus} 
                            maxLength = {props.maxLength}
                            required = {props.required ?? false}
                            name = {props.name} 
                            placeholder = {props.placeholder} 
                            label = {props.label}
                            type = {props.type}
                            value = {props.value} 
                            error = {props.error}
                            disabled = {props.disabled ?? false}
                            onChange = {props.onChange}
                            onBlur = {props.onBlur}
                            componentSideLabel = {renderCheckBox()}
                        />
                    </>
                ) : (
                    <>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}} className='m input-label'>
                            <label className="field-label">
                                {props.label} {props.required && <span style={{color: 'red'}}>*</span>}
                                {renderCheckBox()}
                            </label>
                            <ReactQuill
                                theme="snow"
                                className="react-quill"
                                modules={{ toolbar: toolbarOptions }}
                                style={{ marginBottom: '24px', maxHeight: '200px' }}
                                value={contentActual} 
                                onBlur={(range, source, editor) => handleOnBlurFormato(editor)}
                                onChange={handleOnChangeFormato}
                            />
                            {props.error && 
                                <p className='alert s'>{props.error}</p>
                            }
                        </div>
                    </>
                )
            }
        </>
    )
}